import { useState } from "react";
import { formatNumber, formatPercent } from "../utils";

function hostOf(url) {
    try {
        return new URL(url).hostname.replace(/^www\./, '');
    } catch (error) {
        return '';
    }
}

const VISIBLE = 10;

/** onSelect: 링크를 누르면 상세 (삭제된 링크 제외). Pro 는 클릭된 링크 전체를 받아 '전체 보기' 로 펼친다 */
export function FgTopLinks({ links, totalClicks, onSelect }) {
    const [expanded, setExpanded] = useState(false);

    if (!links.length) {
        return <p className="py-4 text-xs text-gray-400">이 기간에 클릭된 링크가 없습니다.</p>;
    }

    return (
        <>
        <ol className="flex flex-col divide-y divide-gray-100">
            {(expanded ? links : links.slice(0, VISIBLE)).map((link, index) => (
                <li
                    key={link.id ?? `deleted-${index}`}
                    className={`flex items-center gap-3 py-2.5 ${onSelect && !link.deleted ? '-mx-2 cursor-pointer rounded-lg px-2 hover:bg-gray-50' : ''}`}
                    onClick={onSelect && !link.deleted ? () => onSelect(link) : undefined}
                    onKeyDown={onSelect && !link.deleted ? (e) => (e.key === 'Enter' || e.key === ' ') && (e.preventDefault(), onSelect(link)) : undefined}
                    role={onSelect && !link.deleted ? 'button' : undefined}
                    tabIndex={onSelect && !link.deleted ? 0 : undefined}
                >
                    <span className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-bold ${index < 3 ? 'bg-gray-900 text-white' : 'bg-gray-100 text-gray-500'}`}>
                        {index + 1}
                    </span>
                    <div className="min-w-0 flex-1">
                        <p className={`truncate text-[13px] font-semibold ${link.deleted ? 'text-gray-400' : 'text-gray-900'}`} title={link.title || ''}>
                            {link.deleted ? '삭제된 링크' : link.title}
                        </p>
                        {!link.deleted && <p className="truncate text-[11px] text-gray-400">{hostOf(link.linkUrl)}</p>}
                    </div>
                    <div className="shrink-0 text-right">
                        <p className="text-[13px] font-bold">{formatNumber(link.clicks)}</p>
                        <p className="text-[11px] text-gray-400" title="이 링크 클릭 ÷ 페이지 방문">
                            클릭률 {formatPercent(link.clickRate)} · 점유 {totalClicks ? Math.round((link.clicks / totalClicks) * 100) : 0}%
                        </p>
                    </div>
                </li>
            ))}
        </ol>
        {links.length > VISIBLE &&
            <button type="button" onClick={() => setExpanded(!expanded)} className="mt-2 w-full rounded-lg py-2 text-xs font-semibold text-gray-600 hover:bg-gray-50">
                {expanded ? '접기' : `전체 보기 (${links.length})`}
            </button>
        }
        </>
    );
}
